const APP_EVENTS = {
  ADD_TO_CART: "add_to_cart",
  SHOW_PRODUCT: "show_product",
  PRODUCT_SHOW_DESCRIPTION: "product_description",
  PRODUCT_LISTINGS: "product_listings",
  GO_TO_PAGE: "go_to_page",
  AGENT_MESSAGE: "agent_message",
};
export default APP_EVENTS;
